// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"cb25b2df","833":"d43e1f84","952":"90d892ea","964":"349e0412"}[chunkId] + ".chunk.js";
};